export default {
    setAdList(state,val){
        state.adList = val;
    }
}